const initialState = {
  hasLoadAttempt: false,
  isPending: false,
  isSignedIn: false,
  token: null,
  profile: null,
  collections: {},
  cart: null,
  usDollarsNotice: null,
  preferences: {
    searchResultsViewType: 'list',
    searchVideoMuted: false
  }
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case 'getBookmarksForItemsSuccess': {
      const { bookmarks } = action.payload

      let newCollections = Object.assign({}, state.collections)
      bookmarks.forEach(bookmark => {
        if (!newCollections[bookmark.collection.id]) {
          newCollections[bookmark.collection.id] = bookmark.collection
          newCollections[bookmark.collection.id].bookmarks = {}
        }
        newCollections[bookmark.collection.id].bookmarks[bookmark.item_id] = {
          id: bookmark.id
        }
      })
      return {
        ...state,
        collections: newCollections
      }
    }
    case 'addBookmarkRequest': {
      const { collectionID, itemID } = action.payload

      return {
        ...state,
        collections: {
          ...state.collections,
          [collectionID]: {
            ...state.collections[collectionID],
            bookmarks: {
              ...state.collections[collectionID].bookmarks,
              [itemID]: { optimisticStatus: 'pending' }
            }
          }
        }
      }
    }
    case 'addBookmarkSuccess': {
      const { collectionID, itemID, bookmarkID } = action.payload

      return {
        ...state,
        collections: {
          ...state.collections,
          [collectionID]: {
            ...state.collections[collectionID],
            bookmarks: {
              ...state.collections[collectionID].bookmarks,
              [itemID]: { id: bookmarkID, optimisticStatus: 'successful' }
            }
          }
        }
      }
    }
    case 'deleteBookmarkRequest': {
      const { collectionID, itemID } = action.payload

      return {
        ...state,
        collections: {
          ...state.collections,
          [collectionID]: {
            ...state.collections[collectionID],
            bookmarks: {
              ...state.collections[collectionID].bookmarks,
              [itemID]: {
                ...state.collections[collectionID].bookmarks[itemID],
                optimisticStatus: 'deleted'
              }
            }
          }
        }
      }
    }
    case 'deleteBookmarkFailure': {
      const { collectionID, itemID } = action.payload

      let newState = {
        ...state,
        collections: {
          ...state.collections,
          [collectionID]: {
            ...state.collections[collectionID],
            bookmarks: {
              ...state.collections[collectionID].bookmarks,
              [itemID]: { ...state.collections[collectionID].bookmarks[itemID] }
            }
          }
        }
      }

      delete newState.collections[collectionID].bookmarks[itemID]
        .optimisticStatus

      return newState
    }
    case 'deleteBookmarkSuccess':
    case 'addBookmarkFailure': {
      const { collectionID, itemID } = action.payload

      let newState = {
        ...state,
        collections: {
          ...state.collections,
          [collectionID]: {
            ...state.collections[collectionID],
            bookmarks: { ...state.collections[collectionID].bookmarks }
          }
        }
      }

      delete newState.collections[collectionID].bookmarks[itemID]

      return newState
    }
    case 'createCollectionRequest':
      return state
    case 'createCollectionSuccess': {
      const collection = action.payload
      return {
        ...state,
        collections: {
          [collection.id]: { ...collection, bookmarks: {} },
          ...state.collections
        }
      }
    }

    case 'createCollectionFailure':
      return state

    /**
     * User profile
     */
    case 'getUserRequest':
      return {
        ...state,
        isPending: true
      }
    case 'getUserSuccess': {
      const { profile, collections, cart } = action.payload

      return {
        ...state,
        profile,
        collections: collections || state.collections,
        cart,
        hasLoadAttempt: true,
        isPending: false,
        isSignedIn: !!(state.token && profile)
      }
    }

    case 'getUserFailure':
      return {
        ...state,
        profile: null,
        collections: {},
        cart: null,
        hasLoadAttempt: true,
        isPending: false,
        isSignedIn: false
      }

    /**
     * Token
     */
    case 'getSessionRequest':
      return state
    case 'getSessionSuccess': {
      const { token } = action.payload
      return { ...state, token }
    }

    case 'getSessionFailure':
      return {
        ...state,
        token: null,
        hasLoadAttempt: true,
        isPending: false,
        isSignedIn: false
      }

    /**
     * Guest user
     */
    case 'getGuestUser':
      return {
        ...state,
        hasLoadAttempt: true,
        isPending: false
      }
    case 'getGuestUserCartRequest':
      return state
    case 'getGuestUserCartSuccess':
      return { ...state, cart: action.payload }
    case 'getGuestUserCartFailure':
      return state

    /**
     * User cart action
     */
    case 'createUserCartRequest':
      return state
    case 'createUserCartSuccess':
      return { ...state, cart: action.payload }
    case 'createUserCartFailure':
      return state

    case 'addItemToCartRequest':
      return state
    case 'addItemToCartSuccess':
      return {
        ...state,
        cart: {
          ...state.cart,
          entries_count: state.cart.entries_count + 1,
          entries: [...state.cart.entries, action.payload]
        }
      }
    case 'addItemToCartFailure':
      return state

    case 'setUserSearchResultsViewType':
    case 'getUserSearchResultsViewType':
      return {
        ...state,
        preferences: {
          ...state.preferences,
          searchResultsViewType: action.payload.view
        }
      }

    case 'setUserVideoPlayerStatus':
    case 'getUserVideoPlayerStatus':
      return {
        ...state,
        preferences: {
          ...state.preferences,
          searchVideoMuted: action.payload.type
        }
      }
    case 'getUSDollarsNotice': {
      const { usDollarsNotice } = action.payload
      return { ...state, usDollarsNotice }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/user.js